import { Store } from 'libx'
import { observable, computed, action } from 'mobx'
import { task } from 'mobx-task'
import { validationContext, required, pattern } from 'validx'
import autobind from 'autobind-decorator'

@autobind
export default class ChangeEmailDialogStore extends Store {
  @observable showing = false
  @observable email = false

  validation = validationContext()

  rules = {
    email: [
      required('New email is required'),
      pattern({
        pattern: 'email',
        msg: 'Not a valid email address'
      })
    ]
  }

  @computed get user () {
    return this.rootStore.authStore.user
  }

  @action show () {
    this.email = this.user.email
    this.showing = true
  }

  @action close () {
    this.showing = false
  }

  @task.resolved save () {
    if (!this.validation.reset().validate(this, this.rules).isValid) {
      return
    }

    return this.rootStore.userStore.changeEmail(this.email)
      .then(this.emailChanged)
  }

  @action emailChanged () {
    this.close()
    this.rootStore.flashMessageStore.create('E-mail address successfully changed.').done().autoDismiss(4000)
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/ChangeEmailDialogStore.js